import styled from 'styled-components'
import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'

export const MainPage = styled.div`
  display: flex;
  flex-direction: column;
`

export const Header = styled.div`
position: relative;
display: flex;
flex: 0 0 auto;
flex-direction: row;
flex-wrap: wrap;
align-items: center;
min-height: 87px;
font-size: 0.7rem;
background: var(--color-primary);

&::before {
  content: ' ';
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: url('${MoreHeaderParticles}');
  background-repeat: no-repeat;
  background-position: right top;
}
`

export const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

export const Title = styled.h1`
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

export const Content = styled.div`
  padding: 2rem 1.1875rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: auto;
  max-height: 500px;
`
